import React, { useContext, useCallback } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import { IEditCategoryContext, EditCategoryContext } from '../editCategoryState/editCategoryContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { updateCategoryV2 } from 'backend/categories';
import { useGoBack } from 'hooks/useGoBack';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, setFileId, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IEditCategoryContext>(EditCategoryContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/menu-v2/category');
	}, [goBack]);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateCategoryV2(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		setFileId(null);
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'toConfirmSubmit'}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleUpdateData}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'defaultTranslationIsEmpty' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorDefaultTranslationOnBlock"
				/>
			)}
		</ModalWrapper>
	);
};
